module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp mdl-cell mdl-cell--3-col-desktop mdl-cell--4-col-tablet mdl-cell--12-col-phone"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.notetitle))]), _c('button', {
    staticClass: "menu mdl-button mdl-js-button mdl-button--icon mdl-js-ripple-effect",
    attrs: {
      "id": _vm.noteindex
    }
  }, [_c('i', {
    staticClass: "material-icons mdl-color-text--grey-700"
  }, [_vm._v("more_vert")])]), _c('ul', {
    staticClass: "mdl-menu mdl-menu--bottom-right mdl-js-menu mdl-js-ripple-effect",
    attrs: {
      "for": _vm.noteindex
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item",
    on: {
      "click": _vm.editNote
    }
  }, [_vm._v("Edit")]), _c('li', {
    staticClass: "mdl-menu__item",
    on: {
      "click": _vm.deleteNote
    }
  }, [_vm._v("Delete")])])]), _c('div', {
    staticClass: "body"
  }, [_vm._v(_vm._s(_vm.notebody))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37f6070e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Note.vue
// module id = 18
// module chunks = 0